
export default function Testimonials() {
  const testimonials = [
    {
      name: '김민지',
      job: '대학생',
      text: '온니잡 덕분에 학업과 병행할 수 있는 완벽한 아르바이트를 찾았어요. 급여도 정확하게 나오고 업체도 정말 좋아요!',
      type: 'text',
      avatar: 'https://public.readdy.ai/ai/img_res/c7146f1b85e328d536db4c3737b826e7.jpg'
    },
    {
      name: '박준호',
      job: '프리랜서',
      text: '다양한 일자리 정보를 한눈에 볼 수 있어서 너무 편리해요. 지원 프로세스도 간단하고 빠르게 연락이 와서 만족스럽습니다.',
      type: 'text',
      avatar: 'https://readdy.ai/api/search-image?query=young%20korean%20male%20freelancer%20smiling%20portrait%20professional%20headshot%20bright%20background%20confident%20expression&width=200&height=200&seq=test2&orientation=squarish'
    },
    {
      name: '이서연',
      job: '직장인',
      text: '투잡을 찾고 있었는데 온니잡에서 딱 맞는 일자리를 찾았어요. 시간대도 유연하고 급여 지급도 빨라서 추천합니다!',
      type: 'image',
      image: 'https://readdy.ai/api/search-image?query=korean%20professional%20woman%20working%20part%20time%20job%20happy%20satisfied%20expression%20modern%20workplace%20bright%20environment%20positive%20atmosphere&width=400&height=500&seq=test3&orientation=portrait'
    },
    {
      name: '최동욱',
      job: '취업준비생',
      text: '취업 준비하면서 경력도 쌓고 용돈도 벌 수 있어서 정말 좋아요. 온니잡은 제 든든한 파트너입니다.',
      type: 'large',
      image: 'https://readdy.ai/api/search-image?query=young%20korean%20male%20job%20seeker%20working%20part%20time%20confident%20expression%20modern%20office%20environment%20bright%20professional%20atmosphere%20success%20story&width=800&height=500&seq=test4&orientation=landscape'
    },
    {
      name: '정수민',
      job: '주부',
      text: '아이 키우면서 할 수 있는 일을 찾기 어려웠는데, 온니잡에서 시간제 근무를 찾았어요.',
      type: 'small',
      avatar: 'https://readdy.ai/api/search-image?query=korean%20mother%20smiling%20portrait%20professional%20headshot%20bright%20background%20warm%20friendly%20expression&width=200&height=200&seq=test5&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-24 md:py-32 bg-[#F5F5F7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3 md:mb-4">
            <span className="text-[#1A2332] text-lg md:text-xl">◆</span>
            <span className="text-xs md:text-sm font-semibold text-[#1A2332] tracking-wider">REVIEWS</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A2332]">
            온니잡 이용자들의 생생한 후기
          </h2>
        </div>

        {/* 모바일 레이아웃 */}
        <div className="md:hidden space-y-4">
          {testimonials.slice(0, 4).map((testimonial, index) => (
            <div key={index} className="bg-[#E8EAF0] rounded-2xl p-5">
              <div className="flex items-center gap-3 mb-4">
                <div>
                  <div className="font-bold text-[#1A2332]">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.job}</div>
                </div>
              </div>
              <div className="text-2xl text-[#1A2332] mb-2">"</div>
              <p className="text-sm text-gray-700 leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>

        {/* 데스크톱 레이아웃 */}
        <div className="hidden md:grid md:grid-cols-3 gap-5">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <div key={index}>
              {testimonial.type === 'text' ? (
                <div className="bg-[#E8EAF0] rounded-2xl p-8 h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div>
                      <div className="font-bold text-[#1A2332]">{testimonial.name}</div>
                      <div className="text-sm text-gray-600">{testimonial.job}</div>
                    </div>
                  </div>
                  <div className="text-4xl text-[#1A2332] mb-4">"</div>
                  <p className="text-gray-700 leading-relaxed">{testimonial.text}</p>
                </div>
              ) : (
                <div className="relative rounded-2xl overflow-hidden h-full aspect-[3/4]">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1A2332]/90 to-transparent p-6">
                    <div className="font-bold text-white text-lg">{testimonial.name}</div>
                    <div className="text-white/80 text-sm">{testimonial.job}</div>
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="md:col-span-2">
            <div className="relative rounded-2xl overflow-hidden h-full min-h-[400px]">
              <img
                src={testimonials[3].image}
                alt={testimonials[3].name}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1A2332] via-[#1A2332]/80 to-transparent p-8">
                <div className="font-bold text-white text-2xl mb-1">{testimonials[3].name}</div>
                <div className="text-white/80 mb-3">{testimonials[3].job}</div>
                <p className="text-white/90 leading-relaxed max-w-2xl">{testimonials[3].text}</p>
              </div>
            </div>
          </div>

          <div className="space-y-5">
            <div className="bg-[#E8EAF0] rounded-2xl p-6">
              <div className="text-3xl text-[#1A2332] mb-3">"</div>
              <p className="text-gray-700 leading-relaxed mb-4">{testimonials[4].text}</p>
              <div className="flex items-center gap-3">
                <div>
                  <div className="font-bold text-[#1A2332] text-sm">{testimonials[4].name}</div>
                  <div className="text-xs text-gray-600">{testimonials[4].job}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
